export default {
  user: "کاربر",
  users: "کاربران",
  role: "نقش",
  unit: "واحد",
  name: "نام",
  family:"نام و نام خانوادگی بیمار",
  firstName: "نام",
  lastName: "نام‌خانوادگی",
  fullName: "نام‌ و نام‌خانوادگی",
  username: "نام کاربری",
  password: "رمز عبور",
  confirm: "تکرار رمز عبور",
  gender: "جنسیت",
  residential: "محل اقامت",
  nationalCode: "کد‌ملی",
  otherCode: "کد اتباع خارجی",
  issuedProvince: "استان محل صدور",
  // issuedCountry: 'کشور محل صدور',
  issuedCity: "شهر محل صدور",
  birthCity: "شهر محل تولد",
  birthProvince: "استان محل تولد",
  female: "خانم",
  Male: "آقا",
  mobile: "شماره موبایل",
  mobiles: "شماره موبایل ها",
  anotherMobile: " شماره موبایل دیگر",
  dateOfBirth: "تاریخ تولد",
  gregorianDateOfBirth: "تاریخ تولد (میلادی)",
  solarDateOfBirth: "تاریخ تولد (شمسی)",
  fathersName: "نام پدر",
  spouseFirstName: "نام همسر",
  spouseLastName: "نام خانوادگی همسر",
  spouseNationalCode: "کد ملی همسر",
  spouseIdentityCode: "کد اتباع همسر",
  spouseCountryId: "ملیت همسر",
  spouse: "همسر",
  email: "ایمیل",
  nationality: "ملیت",
  dialCode: "کد کشور",
  phone: "تلفن",
  internal: "داخلی",
  maritalStatus: "وضعیت تاهل",
  married: "متاهل",
  single: "مجرد",
  referralWay: "نحوه‌ی آشنایی",
  referrerName: "نام معرف",
  referrerUser: "{user} معتمد",
  referrerAddress: "آدرس معرف",
  addService: "افزودن خدمت",
  userShare: "سهم پزشک",
  userTax: "مالیات پزشک",
  hospitalShare: "سهم مرکز",
  hospitalTax: "مالیات مرکز",
  dateOfMarriage: " تاریخ ازدواج",
  searchForForeigner: "جستجوی {user} غیر ایرانی",
  foreignerInfo: "اطلاعات اتباع",
  searchForUser: "جستجوی {user}",
  contact: "اطلاعات تماس",
  birthCertificateId: "شماره شناسنامه",
  doctorIdentificationCode: "کد شناسایی پزشک",
  rule: "نقش",
  medicalSystemNumber: "شماره نظام پزشکی",
  startDateAtWork: "تاریخ شروع به کار",
  endDateAtWork: "تاریخ پایان کار",
  completionDateOfMedicalLicense: "تاریخ اتمام پروانه پزشکی",
  medicalSpecialtyId: "تخصص",
  medicalScientificDegreeId: "درجه علمی ",
  officeLicenseNumber: "شماره پروانه مطب(در  صورت داشتن مطب)",
  officeLicenseNumberValidation: "شماره پروانه مطب",
  officePhoneNumber: "شماره تلفن مطب",
  officeAddress: "آدرس مطب ",
  statusOfMembership: "وضعیت هیئت علمی",
  accountNumber: "شماره حساب",
  iBAN: "شماره شبا",
  bankId: "نام بانک",
  accountType: "نوع حساب",
  cooperationType: "نوع همکاری",
  contractType: "نوع قرارداد",
  description: "توضیحات ",
  dateOfIssueOfTheDocument: "تاریخ صدور مدرک ",
  fieldOfStudy: "رشته تحصیلی",
  educationalDegree: "تحصیلات",
  address: "آدرس",
  descriptionMama: "توضیحات ",
  nonFullTime: "غیر تمام وقت ",
  fullTimeGeographical: "تمام وقت جغرافیایی ",
  fullTime: "تمام وقت ",
  guest: "مهمان",
  formal: "قراردادی",
  dateOfGraduation: "تاریخ صدور مدرک تحصیلی",
  forefatherName: "نام پدربزرگ",
  typeOfIdentificationDocument: "نوع مدرک شناسایی",
  expiryDateOfIdentityDocument: "تاریخ انقضا مدرک",
  doctorInfo: "اطلاعات پزشکی",
  doctorAccountInfo: "اطلاعات حساب پزشک",
  nurseAndMidwifeInfo: "اطلاعات  ماما و پرستار",
  personalInfo: "اطلاعات فردی",
  job: "شغل",
  spouseJob: "شغل همسر",
  spouseEducationalDegree: "تحصیلات همسر",
  legalExpertInfo: "اطلاعات وکیل",
  legalFileNumber: "شماره پروانه وکالت",
  insuranceNumber: "شماره بیمه",
  fileNumber: "شماره پرونده",
  referralWayRole: {
    doctorsOfTheCountryOfOrigin: "نام پزشک کشور مبدا",
    agent: "نام واسطه",
    referralDoctor: "دکتر‌های معرف",
    introducingFriends: "نام معرف",
  },
  socialNetworks: "شبکه‌های اجتماعی",
  doctorName: "نام پزشک",
  typeOfIdentificationDocuments: {
    passport: "پاسپورت",
    biography: "تذکره",
    citizen_identification_document: "کارت اقامت",
    rental: "اجاره نامه",
    contract_booklet: "دفترچه عقد",
  },
  both: "ایرانی و خارجی",
  iranian: "ایرانی",
  foreign: "خارجی",
  messageType: "نوع پیام",
  messageTime: "زمابندی ارسال",
  messageTimeUnit: "واحد زمان",
  messageTimeState: "وضعیت زمان پیام",
  messageTimeValue: "زمان ارسال",
  message: "پیام",
  roles: "نقش ها",
  units: "واحد ها",
  action:"عملیات",
  reference:"مراجعه",
  turnStatus:"وضعیت نوبت",
  ReferralStatus:"وضعیت مراجعه",
  nationalCodeN:"کدملی/ملیت",
};
